import smoothscroll from 'smoothscroll-polyfill';
import logger from 'src/logger';

// Polyfill for window.scrollTo
if (typeof window !== 'undefined') {
  smoothscroll.polyfill();
}

export const getRect = selector => {
  const target = document.querySelector(selector);
  return target.getBoundingClientRect();
};

export const getOffset = (selector, newTop) => {
  if (selector) {
    const { top, height } = getRect(selector);

    if (top < newTop) {
      return height;
    }
  }

  return 0;
};

const scrollToElement = (element, { offset = 0, collapsibleSelector, headerSelector = 'header' } = {}) => {
  const { top } = element.getBoundingClientRect();
  const { height: headerOffset } = getRect(headerSelector);
  // Offset against any collapsing selectors to ensure scroll doesn't miss
  const collapsibleOffset = getOffset(collapsibleSelector, top);

  window.scrollTo({
    top: top + window.pageYOffset - (offset + headerOffset + collapsibleOffset),
    behavior: 'smooth'
  });
};

export const scrollToParent = (selector, options = {}) => {
  const target = document.querySelector(selector);
  if (!target) {
    logger.warn(`Unable to scroll to missing element: "${selector}"`);
    return;
  }
  scrollToElement(target.parentNode, options);
};

export default (selector, options = {}) => {
  let target = document.querySelector(selector);
  if (!target) {
    logger.warn(`Unable to scroll to missing element: "${selector}"`);
    return;
  }
  scrollToElement(target, options);
};




// WEBPACK FOOTER //
// ./src/client/js/view/utils/scrollTo.js